import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bySelected',
  pure: false,
  standalone: false
})
export class BySelectedPipe implements PipeTransform {
  public transform(items: any[]): any[] {
    return items.filter((item) => item.IsSelected);
  }
}
